import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useMetadata from '@/hooks/data/useMetadata';
import MetadataContext from '@/contexts/data/MetadataContext';
import IsLoading from '@/components/layouts/IsLoading';
import TrialContext from '@/contexts/data/TrialContext';
import { GetMetadataResponse } from '@/api/dtos';


export interface IMetadataProviderProps {
    initial?: GetMetadataResponse;
}

export const MetadataProvider: FC<PropsWithChildren<IMetadataProviderProps>> = ({ initial, children }) => {
    const { data: trial } = useContext(TrialContext);
    const metadata = useMetadata(trial ? trial.id : undefined, { revalidateOnFocus: false, fallbackData: initial});

    return (
        <MetadataContext.Provider value={metadata}>
            <IsLoading name="metadata" loading={metadata.loading} validating={metadata.validating}/>
            {children}
        </MetadataContext.Provider>
    );
}

export default MetadataProvider;
